import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { RestBookDao } from '../daos/book-dao';
import { SemanticWebDao } from '../daos/semantic-web-dao';
import { AwardWinner, Book } from '../model/models';

@Injectable({
  providedIn: 'root'
})
export class AwardService {

  constructor(
    private semanticWebDao: SemanticWebDao,
    private bookDao: RestBookDao) { }

  syncAwards(existingBooks: Book[]): Observable<Book[]> {
    return this.semanticWebDao.getAwardWinners().pipe(
      mergeMap(winners => this.toBooks(winners, existingBooks))
    );
  }

  private toBooks(winners: AwardWinner[], existingBooks: Book[]): Observable<Book[]> {
    const booksById = new Map<string, Book>();
    const books$: Observable<Book>[] = [];

    existingBooks.forEach(book => {
      booksById.set(book.wikidataId, book)
      books$.push(of(book));
    });

    winners.forEach(winner => {
      const awardWin = { award: winner.award, year: winner.year };
      let book = booksById.get(winner.bookId);
      if (!!book) {
        if (!book.awardWins.find(win => win.award == winner.award)) {
          book.awardWins.push(awardWin);
        }
      }
      else {
        book = { wikidataId: winner.bookId, awardWins: [awardWin] } as Book;
        booksById.set(winner.bookId, book);
        books$.push(this.semanticWebDao.getBook(winner.bookId).pipe(
          mergeMap(bookDetail => this.bookDao.saveBook({ ...book, ...bookDetail }))
        ));
      }
    });
    return forkJoin(books$);
  }

  // syncAwards(existingBooks: Book[]): Observable<Book[]> {
  //   const a = this.awardDao.getAwardWinners().pipe(
  //     map(winners => winners.filter(winner => !existingBooks.find(book => book.id == winner.bookId))),
  //     map(winners => this.toBaseBookList(winners)),
  //     mergeMap(newBooks => this.toCompleteBookList$(newBooks, existingBooks))
  //   );
  //   return a;
  // }
  // private toCompleteBookList$(newBooks: Book[], existingBooks: Book[]): Observable<Book[]> {
  //   const newBooks$ = newBooks.map(book => this.bookDao.getBook(book.id).pipe(
  //     map(bookDetail => ({ ...book, ...bookDetail } as Book))));
  //   const existingBooks$ = existingBooks.map(book => of(book));
  //   return forkJoin([...existingBooks$, ...newBooks$]);
  // }

  // private toBaseBookList(winners: AwardWinner[]): Book[] {
  //   const booksById = new Map<string, Book>();
  //   winners.forEach(winner => {
  //     const awardWin = { award: winner.award, year: winner.year };
  //     const book = booksById.get(winner.bookId);
  //     if (!!book) {
  //       book.awards.push(awardWin);
  //     }
  //     else {
  //       booksById.set(winner.bookId, {
  //         id: winner.bookId,
  //         awards: [awardWin]
  //       } as Book)
  //     }
  //   });
  //   return [...booksById.values()];
  // }
}
